module.exports = __webpack_public_path__ + "assets/audio/353bed5d38b3e925139df35442fb753b.mp3";